function colourSelect() {
  $('select.product-colours.mobile').on('change', function () {
      var url = $(this).val(); 
      if (url) { 
          window.location = url; 
      }
      return false;
  });
}

function outputColourSwatchProducts(json, currentProductID) {

//   console.log('outputcolourswatchproducts');
//   console.log('json ' + json);
//   console.log('productID' + currentProductID);
  
  var listMarkup = '<ul class="product-colours">',
      productColourContainer = $('.product-colours-container');

  //for each product
  for (var key in json.products) {
      var productColour = json.products[key]['colour'],
          productURL = json.products[key]['url'],
          productID = json.products[key]['id'],
          activeClass = "",
          selected = "";

      //if current product ID matches the product ID in the loop, set active class and selected option.    
      if (productID === currentProductID) {
          activeClass = " current";
          selected = ' selected="selected"';
      }

      //Add option product to the list and select markup
      listMarkup += '<li class="colour__li '+activeClass+'"><a href="'+productURL+'" class="'+productColour.toLowerCase()+'">'+productColour+'</a></li>';

  }

  //close list and select markup
  listMarkup += '</ul>';

  //output the results.
  productColourContainer.append(listMarkup);
  productColourContainer.removeClass('d-none');

  detectiOSColourTap();
  colourSelect();

}

function getMatchingProductsByTag() {
  if ($('.product-colours-container').length) {
      var colourGroupName = $('.product-colours-container').attr('data-colour-group'),
          currentProductID = $('.product-colours-container').attr('data-current-product-id'),
          currentCollection = $('.product-colours-container').attr('data-current-collection-handle');

          //Check to see if the current product is within a collection. if it's not default to 'all'
          //UPDATE: not all the colour variants sit within the same collection.
          if (!currentCollection) {
              currentCollection = 'all'
          }
    
//     	  console.log(colourGroupName);
//           console.log(currentProductID);
//           console.log(currentCollection);

      $.ajax({
          type: 'GET',
          url: '/collections/'+currentCollection+'/' + colourGroupName + '?view=colour',
          success: function (data) {
            
//               console.log(data);
            
              if(data) {
                  try {
                      var json = JSON.parse(data);
                  } catch(e) {
                      var json = null; // meh
                  }
              }
              //if Json is sucessful, pass over to function to output the results.
              if (json) {
                  outputColourSwatchProducts(json,currentProductID);
              }
          }
      });
  }
}

if ($('body.template-product').length) {
   getMatchingProductsByTag();
   detectiOSAddtoCartTap();
}

//Detect iOS taps on the PDP colour selectors, preventing the need for double taps.
function detectiOSColourTap() {
  
  var swatchElementColour = $('.colour__li');
  
  swatchElementColour.each(function(){
    
    $(this).off('touchstart click').on('touchstart click', function(e) {
//       console.log('click');
    });
  });
}

//Detect iOS taps on the add to cart button, preventing the need for double taps.
function detectiOSAddtoCartTap() {
  
  var addButton = $('.btn--addToCart');
  
  addButton.each(function(){
    
    $(this).off('touchstart click').on('touchstart click', function(e) {
//       console.log('click');
    });
  });
}